import React from 'react'

import { Box } from '@chakra-ui/react'
import { WarningMessage } from 'src/components/WarningMessage/WarningMessage'
import { Paths } from 'src/constants/paths'
import { ForgetPasswordModal } from 'src/legacy_modules/auth/password/forget/forget-password-modal'

export const ChangePasswordPage: React.FC = () => {
  return (
    <Box>
      <ForgetPasswordModal
        onClose={() => {
          window.location.href = Paths.Dashboard
        }}
        closable={false}
        additionalMessage={
          <WarningMessage message="パスワードの有効期限が切れています。" />
        }
      />
    </Box>
  )
}
